import type { FC } from 'react';
import dayjs from 'dayjs';
import { ContainedListItem, Tag } from '@carbon/react';

import type { NotificationItem } from '@maestra/core/interfaces/maestra';
import styles from './Notificacoes.module.scss';

// UM AVISO DA LISTA, o mesmo na página e no painel do sino: um item clicável (abre o destino e marca
// como lido) com o título, a mensagem, a hora e a `Tag` "Nova" nos não lidos. `empilhado` (o painel,
// estreito) põe a etiqueta e a hora embaixo do texto em qualquer largura.

export const ItemDeNotificacao: FC<{ n: NotificationItem; abrir: (n: NotificationItem) => void; empilhado?: boolean }> = ({ n, abrir, empilhado }) => (
  // O nome do item para o leitor de tela é o próprio conteúdo, com a etiqueta "Nova".
  <ContainedListItem onClick={() => abrir(n)}>
    <div className={`${styles.aviso} ${empilhado ? styles.empilhado : ''}`}>
      <div className={styles.corpo}>
        <p className={n.read ? styles.titulo : styles.tituloNaoLido}>{n.title}</p>
        {n.message && <p className={styles.mensagem}>{n.message}</p>}
      </div>
      <div className={styles.lado}>
        {!n.read && <Tag size='sm' type='blue'>Nova</Tag>}
        <time className={styles.hora} dateTime={n.created_at ?? undefined}>
          {n.created_at ? dayjs(n.created_at).format('DD/MM/YYYY HH:mm') : 'Agora'}
        </time>
      </div>
    </div>
  </ContainedListItem>
);
